/*
 * SlideRoller is a component for browsing content in slides
 * Use: new SlideRoller('.my-slide-class');
 */
function SlideRoller(slides, options) {
    options = options || {};

    this.slides = jQuery(slides);
    this.updateCallback = options.updateCallback;
    this.interval = options.interval || 5000; // ms
    this.slideTimeout = options.slideTimeout || 10000; // ms after manual slide change
    this.transitionDuration = options.transitionDuration || 1000; // ms
    this.randomPlay = options.randomPlay || false;
    this.currentSlide = (options.initialSlide && options.initialSlide <= this.slides.length) ? options.initialSlide - 1 : 0;
    this.autoStart = options.autoStart != null ? options.autoStart : true;
    this.timer = null;
    this.slideTimeoutTimer = null;
    this.slideSelector = null;

    // Wrap slides
    this.slides.wrapAll('<div class="slides" />');
    this.slides.closest('.slides').wrapAll('<div class="slide-roller" />');
    this.container = this.slides.closest('.slide-roller');

    if (this.slides.length > 1) {
        // Create slide selector
        this.container.append('<div class="slide-selector"></div>');
        this.slideSelector = this.container.find('.slide-selector');

        this.slides.each(jQuery.proxy(function(i, slide) {
            jQuery(slide).addClass('slide').attr('data-slide', i + 1);
            this.slideSelector.append('<a href="#" class="dot" data-slide="' + (i + 1) + '"></a>');
        }, this));

        // Slide selector events
        this.slideSelector.find('.dot').on('click', jQuery.proxy(function(e) {
            this.changeSlide(parseInt(jQuery(e.currentTarget).attr('data-slide'), 10));
            return false;
        }, this));

        // Start slide rotation
        if (this.autoStart) {
            this.play();
        }
    } else if (this.autoStart) {
        // Nothing to rotate but call the update callback once
        if (this.updateCallback) {
            this.updateCallback(this.slides.first());
        }
    }

    jQuery(window).on('resize', jQuery.proxy(this.resize, this));
    this.resize();
};

SlideRoller.prototype.update = function() {
    if (this.nextSlide) {
        this.currentSlide = this.nextSlide;
    } else {
        if (this.randomPlay) {
            this.currentSlide = Math.ceil(Math.random() * this.slides.length);
        } else {
            this.currentSlide = 1;
        }
    }

    if (this.randomPlay) {
        this.nextSlide = Math.ceil(Math.random() * this.slides.length);
    } else {
        this.nextSlide = (this.currentSlide >= this.slides.length) ? 1 : this.currentSlide + 1;
    }

    var newSlide = this.slides.filter('[data-slide="' + this.currentSlide + '"]');
    newSlide.css('background-image', 'url('+newSlide.data('background')+')');

    // Fade out this and fade in next slide
    if (this.slides.length > 1) {
        this.slides.fadeOut(this.transitionDuration);
        newSlide.fadeIn(this.transitionDuration);
        
        // Update slide selector dots
        this.slideSelector.find('.dot').removeClass('active');
        this.slideSelector.find('.dot[data-slide="' + this.currentSlide + '"]').addClass('active');
    }

    if (this.updateCallback) {
        this.updateCallback(newSlide);
    }

    // prepare next slide
    var nextSlide = this.slides.filter('[data-slide="' + this.nextSlide + '"]');
    nextSlide.css('background-image', 'url('+nextSlide.data('background')+')');
}

SlideRoller.prototype.changeSlide = function(slideNum) {
    this.pause();
    this.currentSlide = slideNum - 1;
    this.update();

    // Continue slide rotation after a timeout
    this.slideTimeoutTimer = setTimeout(jQuery.proxy(this.play, this), this.slideTimeout);
}

SlideRoller.prototype.play = function() {
    if (this.slides.length > 1) {
        this.timer = setInterval(jQuery.proxy(this.update, this), this.interval);
    }
    this.update();
}

SlideRoller.prototype.pause = function() {
    clearInterval(this.timer);
    clearTimeout(this.slideTimeoutTimer);
}

SlideRoller.prototype.resize = function() {
    // Resize to max slide height
    var maxSlideHeight = 0;
    var h = 0;
    this.slides.each(function(i, s) {
        h = jQuery(s).outerHeight(false);
        if (h > maxSlideHeight) { maxSlideHeight = h; }
    });
    this.container.find('.slides').css('height', maxSlideHeight);
}

window.SlideRoller = SlideRoller;
